<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF" >{{pageTitle[tabsActive]}}</span>
    </div>
    <el-tabs class="el-tabs-self" v-model="tabsActive">
      <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.lable" :name="item.value"></el-tab-pane>
    </el-tabs>
    <component :is="curtTabCompnents[tabsActive]"></component>
  </el-card>

  <el-card>
    <el-form>
      <el-row :gutter="30" style="text-align: center">
        <el-col span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import MixinCUD from "@/components/MixinCUD";
import SmsSameComponent from "@/components/SmsSameComponent";
import SmsCustomComponent from "@/components/SmsCustomComponent";

export default {
name: "SmsSameConfig",
  mixins:[MixinCUD],
  components: {
    SmsSameComponent,
    SmsCustomComponent
  },
  data(){
    return {
      tableData: [
        {
          attach: "允许使用优惠券及红包",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "需要假聊",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "收藏店铺",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "收藏宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "允许使用信用卡",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "允许使用花呗",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "地域限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "年龄限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "性别限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "货比足迹",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "浏览目标宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "优质号",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "竟品",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "商家自主审核",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "任务标签",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "允许使用优惠券及红包",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "意向标签",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "核对商品链接",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "账号等级限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "淘气值限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "收货时间限制",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "浏览副宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },
        {
          attach: "核验码",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "加入购物车",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "多链接",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "问大家",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "回答大家",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "点赞",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "评论问大家",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "推荐宝贝",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "降权包赔",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "7天内完成浏览单",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "旺旺本品打标",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "直播互动留言",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "自动验号",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "旺旺竟品打标",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        },{
          attach: "设定买家的浏览时间",
          servicePrice: "0.0",
          chargesPrice: "0.0",
          isNeedUser: true,
          isDefault: false,
          sorlData: 1
        }
      ],
      pageTitle: {
        1: "短信配置[通用]",
        2: "短信配置[试客端]"
      },
      curtTabCompnents:{
        1:"SmsSameComponent",
        2:"SmsCustomComponent"
      },
      tabsActive: 1,
      tabsActives: {
        1:{
          lable:"通用配置",
          value: 1
        },
        2:{
          lable: "试客端配置",
          value: 2
        }
      },
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.demo-input-suffix {
  margin-bottom: 15px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}

span{
  text-align: center;
}
.tb-edit .el-input {
  display: none
}
.tb-edit .current-row .el-input {
  display: block
}
.tb-edit .current-row .el-input+span {
  display: none
}
</style>
